import React from 'react'
import Icon from '@jarvis.oddle/core/decorators/Icon'
import { IconInterface } from './IconInterface'

const IconNewCancelledOrder = ({
  className,
  height,
  width,
  fill
}: IconInterface) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox='0 0 100 100'
      fill={fill || 'none'}
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect
        x='0.5'
        y='0.5'
        width='99'
        height='99'
        rx='15.5'
        fill='white'
        stroke='#D6D6D6'
      />
      <path
        d='M50.0002 22.0103C34.7985 22.0103 22.5106 34.2981 22.5106 49.4998C22.5106 64.7016 34.7985 76.9894 50.0002 76.9894C65.2019 76.9894 77.4898 64.7016 77.4898 49.4998C77.4898 34.2981 65.2019 22.0103 50.0002 22.0103ZM63.745 59.3686L59.869 63.2446L50.0002 53.3759L40.1314 63.2446L36.2554 59.3686L46.1242 49.4998L36.2554 39.6311L40.1314 35.755L50.0002 45.6238L59.869 35.755L63.745 39.6311L53.8762 49.4998L63.745 59.3686Z'
        fill='#D62105'
      />
    </svg>
  )
}

export default Icon(IconNewCancelledOrder)
